import VideoTemplateApi from 'Api/TemplateCreator/VideoTemplate';
import VideoApi from 'Api/CarePlan/Video';

class VideoTemplateDispatcher {
  constructor(parentId, isTemplate, id = null) {
    this.parentId = parentId;
    this.isTemplate = isTemplate;
    this.id = id;
  }

  create(data) {
    return this.api.create(data);
  }

  update(data) {
    return this.api.update(data);
  }

  destroy() {
    return this.api.destroy();
  }

  get api() {
    if (this.isTemplate) {
      return new VideoTemplateApi(this.parentId, this.id);
    } else {
      return new VideoApi(this.parentId, this.id);
    }
  }
}

export default VideoTemplateDispatcher;
